<template>
  <v-footer>
    <v-card
      elevation="0"
      rounded="0"
      width="100%"
      class="text-center"
    >
      <v-card-text>
        <v-btn
          class="mx-4"
          icon="mdi-home"
          variant="plain"
          to="/"
        ></v-btn>
        <v-tooltip text="Помощь" location="top" :max-height="40">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              class="mx-4"
              icon="mdi-help-circle"
              variant="plain"
              to="/help"
            ></v-btn>
          </template>
        </v-tooltip>
        <v-tooltip text="Контакты" location="top" :max-height="40">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              class="mx-4"
              icon="mdi-account-group"
              variant="plain"
              to="/contacts"
            ></v-btn>
          </template>
        </v-tooltip>
        <v-tooltip text="О нас" location="top" :max-height="40">
          <template v-slot:activator="{ props }">
            <v-btn
              v-bind="props"
              class="mx-4"
              icon="mdi-information"
              variant="plain"
              to="/about"
            ></v-btn>
          </template>
        </v-tooltip>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-text class="my-0">
        2018 - {{ new Date().getFullYear() }} — <strong>sert4game.ru</strong>&copy;
      </v-card-text>
    </v-card>
  </v-footer>
</template>
